import React, { useEffect, useState } from 'react'
import NavButton from './NavButton'
import NavSubMenu from './NavSubMenu'
import { useKeyboardIndex } from './useKeyboardIndex'



const DisclosureItem = ({
    item,
    isExpanded,
    hasFocus,

    onSetMainIndex,
    toggleExpanded,
    handleMainKeyDown,
    handleMainOnFocus
}) => {

    const menuId = `id_menu_${item.id}`


    const handleEscape = () => {
        toggleExpanded(false)
        handleMainOnFocus()
    }

    const [index, setIndex, handleKeyDown, handleOnFocus] = useKeyboardIndex(item.children.length, handleEscape)


    const handleKeyDownButton = (event) => {
        if(isExpanded && event.key === 'ArrowDown') {
            event.preventDefault()
            onSetMainIndex(-1)
            setIndex(0)
        } else {
            handleMainKeyDown(event)
        }
    }


    useEffect(() => {
        if(!isExpanded && index !== -1) {
            setIndex(-1)
        }
    }, [isExpanded])
    

    return (
        <>
            <NavButton
                item={item}
                menuId={menuId}
                isExpanded={isExpanded}
                hasFocus={hasFocus}
                handleKeyDown={handleKeyDownButton}
                toggleExpanded={toggleExpanded}
                handleOnFocus={handleMainOnFocus}
            />

            <NavSubMenu
                menuId={menuId}
                isExpanded={isExpanded}
                items={item.children}

                handleKeyDown={handleKeyDown}
                handleOnFocus={handleOnFocus}

                index={index}
            />
        </>
    )

}

export default DisclosureItem